import { useConstant } from "../../../../hooks/index.js";
function useTexts(texts) {
  return useConstant(() => ({
    saveLabel: "Save",
    title: "Current theme customization",
    ...texts
  }));
}
export {
  useTexts
};
//# sourceMappingURL=useTexts.js.map
